exports.API = {
    DATA : 'https://alertsdataapi.onrender.com',
} 
